import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { horizonAuthModule } from './modules/auth';
import { horizonMovePlugin } from './modules/move';
import {
  horizonCapabilitiesPlugin,
  horizonHomePlugin,
} from './modules/capabilities';
import { navModule } from './modules/nav';
import { horizonSourcePickerModule } from './modules/sourcePicker';
import { horizonAssessPlugin } from './modules/assess';

export default createApp({
  features: [
    catalogPlugin,
    horizonAuthModule,
    horizonMovePlugin,
    horizonHomePlugin,
    horizonCapabilitiesPlugin,
    horizonSourcePickerModule,
    horizonAssessPlugin,
    navModule,
  ],
});
